import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-list-stack.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var ContentListStack = /** @class */ (function (_super) {
    tslib_1.__extends(ContentListStack, _super);
    function ContentListStack(element) {
        return _super.call(this, element) || this;
    }
    ContentListStack.prototype.init = function () {
        if (this.element.querySelector('.content-list-stack__carousel--swiper')) {
            this.blueCarouselSliderPagination = this.element.querySelector('.swiper-pagination');
            this.blueCarouselSliderContainer = this.element.querySelector('.content-list-stack__carousel--swiper');
            this.blueCarouselSlider = new Swiper(this.blueCarouselSliderContainer, {
                slidesPerView: 3,
                centeredSlides: false,
                spaceBetween: 30,
                initialSlide: 0,
                breakpoints: {
                    1024: {
                        initialSlide: 0,
                        slidesPerView: 2.5,
                        spaceBetween: 10,
                    },
                    767: {
                        initialSlide: 0,
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    580: {
                        initialSlide: 0,
                        slidesPerView: 1.2,
                        spaceBetween: 10,
                    }
                },
                freeMode: false,
                pagination: {
                    el: this.element.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true
                },
                navigation: {
                    nextEl: this.element.querySelector('.swiper-button-next'),
                    prevEl: this.element.querySelector('.swiper-button-prev')
                }
            });
        }
    };
    ;
    ContentListStack.prototype.bindEvents = function () { };
    ;
    return ContentListStack;
}(Base));
export { ContentListStack };



//////////////////
// WEBPACK FOOTER
// ./components/content-list-stack/content-list-stack.component.ts
// module id = 233
// module chunks = 0